const base = import.meta.env.DEV
  ? "/admin-api"
  : ((import.meta.env.VITE_ADMIN_SERVER_URL as string) || "/admin-api");

function join(path: string) {
  if (!base) return path; // fallback
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${base}${p}`;
}

export async function adminGet(path: string, init?: RequestInit) {
  return fetch(join(path), init);
}

export async function adminPost(path: string, body: unknown, init?: RequestInit) {
  return fetch(join(path), {
    method: "POST",
    headers: { "Content-Type": "application/json", ...(init?.headers || {}) },
    body: JSON.stringify(body),
    ...init,
  });
}

export async function adminHealth(): Promise<boolean> {
  try {
    const resp = await adminGet("/health");
    return !!resp?.ok;
  } catch {
    return false;
  }
}
